<template>
    <div class="p-4 mb-3 bg-light rounded not-print">
        <ol class="list-unstyled mb-0">
            <li v-if="(session.newType == 0 || session.accPayGrafik == 1) && session.kredit && session.loginId != '2768'"><router-link to="/additionalFeatures/paymentsSchedule">График платежей</router-link></li>
            <li><router-link to="/additionalFeatures/payers">Выбор действующих плательщиков</router-link></li>
            <li><router-link to="/additionalFeatures/POA">Доверенность на получение ТМЦ</router-link></li>
            <li><router-link to="/additionalFeatures/deliveries">Планируемые поставки</router-link></li>
            <li v-if="session.newType == 0 || session.accBalans == 1"><router-link to="/additionalFeatures/balance">Баланс взаиморасчетов</router-link></li>
            <li v-if="session.newType == 1 && session.parent == 0"><router-link to="/additionalFeatures/addNewUser">Добавление пользователей</router-link></li>
            <li v-if="session.newType == 1 && session.parent == 0"><router-link to="/additionalFeatures/manageUsers">Редактирование пользователей</router-link></li>
            <li v-if="session.loginId != 2768 && session.newType == 1"><router-link to="/additionalFeatures/parameters">Параметры учетной записи</router-link></li>
            <li><a href="/additionalFeatures/pushSubscribe">Настройка push-уведомлений</a></li>
            <li><router-link to="/additionalFeatures/textures">Текстуры материалов</router-link></li>
            <li><router-link to="/additionalFeatures/priceLists">Действующие Прайс-листы</router-link></li>
            <li><a href="https://sale.katris.ru/files/blank.doc" target="_blank">Бланк рекламации</a></li>
            <li><router-link to="/additionalFeatures/presentations">Презентации</router-link></li>
            <li><router-link to="/additionalFeatures/manuals">Инструкции по настройке пульта и привода</router-link></li>
            <li><router-link to="/additionalFeatures/videos">Видео</router-link></li>
            <li><a href="#" @click="$modal.show('modalDownload')">Рекламные материалы для<br/> изделий RM</a><span style="float: right; font-weight: bold; color: #0585bd; margin-top: -23px;">NEW</span></li>
        </ol>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modalDownload"
               width="600px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="text-center">Уважаемые партнеры!</h2>

                        <p>Изображения и видео, представленные в данном разделе, принадлежат ООО "Фирма "КАЛИТА".</p>

                        <p>Уникальные изображения и видео, предоставленные нами, помогут вам создавать привлекательный контент для карточек товаров на маркетплейс-платформах. Наш материал позволит вам выделиться среди конкурентов и привлечь больше внимания покупателей. Разнообразие изображений, а также полезные видеоинструкции по установке изделий помогут вам эффективно представить продукцию и наглядно убедить клиентов в ее качестве, простоте установки и комфорте при использовании.</p>

                        <p>Мы предоставляем вам:</p>
                        <p>- изображения продукции в интерьере или на прозрачном/белом фоне. Вы можете добавлять на изображения свой текст и графику, которые сочтете нужными и полезными для потребителя.</p>
                        <p>- видеоинструкции для самостоятельной установки изделий. Данные видео представляют собой готовое решение, любые изменения в них возможны только по согласованию с ООО "Фирма "КАЛИТА"</p>

                        <p>Использовать данный контент рекомендуется только с целью рекламы, продвижения или представления информации об изделия стандартных размеров, которые производит ООО "Фирма "КАЛИТА".</p>

                        <p>Использование данных изображений и видео не по назначению или для рекламы, продвижения или представления продукции других производителей запрещено.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <a class="btn btn-primary btn-block mb-2" href="https://cloud.foroom.ru/index.php/s/sQR5llT6se6kVZC" target="_blank" @click="$modal.hide('modalDownload')">Ознакомлен, продолжить</a>
                    </div>
                    <div class="col-md-6">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть"
                               @click="$modal.hide('modalDownload')"/>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        name: "AdditionalFeaturesMenu",
        data() {
            return {
                session: this.$session.get('user')
            }
        },
    }
</script>

<style scoped>

</style>
